<mat-card>
  <mat-card-content fxLayout="row wrap" fxLayoutGap="16px">
    <div fxFlex.gt-sm="300px">
      @if (artist().images) {
      <img [src]="artist().images" [alt]="artist().name" style="max-width: 100%; border-radius: 4px;" />
      }
    </div>
    <div fxFlex>
      <div class="artist-header-info">
        <p class="artist-name-line"><strong>Artist Name:</strong> {{artist().name}}
          @if (artist().id) {
          <app-favourite-heart [saved]="artistFavourites.ids().has(artist().id)" [name]="artist().name" list="Favourite Artists"
            (toggled)="artistFavourites.toggle(artist().id, artist().name)" />
          }
        </p>
        <p><strong>Popularity:</strong> {{artist().popularity}}</p>
        <p><strong>Genres:</strong></p>
        <mat-chip-set>
          @for (g of artist().genre; track g) {
          <mat-chip>{{g}}</mat-chip>
          }
        </mat-chip-set>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<app-related-artists [artistId]="artist().id" [artistName]="artist().name" />

<br />
<h1>Full Discography</h1>
<div fxLayout="row wrap" fxLayoutGap="16px">
  @for (x of albums(); track x.id) {
  <div fxFlex="100" fxFlex.gt-sm="45" fxFlex.gt-md="30">
    <mat-card style="margin-bottom: 16px;">
      <mat-card-content fxLayout="column" fxLayoutGap="10px">
        <div class="album-cover-container">
          <img [routerLink]="['/album', x.id]" [src]="x.images" [alt]="x.name"
            style="width: 100%; cursor: pointer; border-radius: 4px;" />
        </div>
        <div class="album-details">
          <p class="album-line"><strong>Album:</strong> {{x.name}}
            <button type="button" class="heart" [class.saved]="favourites.ids().has(x.id)" (click)="toggleFavourite(x)"
              [attr.aria-pressed]="favourites.ids().has(x.id)"
              [attr.aria-label]="(favourites.ids().has(x.id) ? 'Remove from' : 'Add to') + ' Favourite Albums: ' + x.name"
              [title]="favourites.ids().has(x.id) ? 'Remove from Favourite Albums' : 'Add to Favourite Albums'">
              <mat-icon>{{favourites.ids().has(x.id) ? 'favorite' : 'favorite_border'}}</mat-icon>
            </button>
          </p>
          <p><strong>Release Date:</strong> {{x.release_date}}</p>
          <p><strong>Tracks:</strong> {{x.total_tracks}}</p>

          <mat-chip-set aria-label="Artist selection">
            @for (ar of x.artists; track ar.id) {
            <mat-chip>{{ar.name}}</mat-chip>
            }
          </mat-chip-set>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }
</div>